// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Activity_domains__zgIfo {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}
.Activity_domains__zgIfo li {
  width: calc(50% - 4px);
  display: flex;
  align-items: center;
  background-color: #FFF;
  border: 1px solid #00007a;
  border-radius: 8px;
  padding: 12px;
  list-style-type: none;
  cursor: pointer;
}
.Activity_domains__zgIfo li svg {
  width: 20px;
  height: auto;
  margin-right: 8px;
}
.Activity_domains__zgIfo li span {
  width: calc(100% - 28px);
  font-size: 14px;
  font-weight: 400;
  color: #00007a;
}

@media screen and (max-width: 600px) {
  .Activity_domains__zgIfo li {
    width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/RCPro/pages/Activity/Activity.module.scss","webpack://./src/styles/colors.scss"],"names":[],"mappings":"AAEA;EACI,aAAA;EACA,QAAA;EACA,eAAA;AAKJ;AAHI;EACI,sBAAA;EACA,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,qBAAA;EACA,eAAA;AAKR;AAHQ;EACI,WAAA;EACA,YAAA;EACA,iBAAA;AAKZ;AAFQ;EACI,wBAAA;EACA,eAAA;EACA,gBAAA;EACA,cCrBD;ADyBX;;AACA;EACI;IACI,WAAA;EAEN;AACF","sourcesContent":["@use 'styles/colors.scss';\n\n.domains{\n    display: flex;\n    gap: 8px;\n    flex-wrap: wrap;\n\n    li{\n        width: calc(50% - 4px);\n        display: flex;\n        align-items: center;\n        background-color: #FFF;\n        border: 1px solid colors.$primary8;\n        border-radius: 8px;\n        padding: 12px;\n        list-style-type: none;\n        cursor: pointer;\n\n        svg{\n            width: 20px;\n            height: auto;\n            margin-right: 8px;\n        }\n\n        span{\n            width: calc(100% - 28px);\n            font-size: 14px;\n            font-weight: 400;\n            color: colors.$primary8;\n        }\n    }\n}\n\n@media screen and (max-width: 600px) {\n    .domains li{\n        width: 100%;\n    }\n}","$primary1: #f5f5ff;\n$primary2: #d8d8ff;\n$primary3: #8686ff;\n$primary4: #4343ff;\n$primary5: #1414ff;\n$primary6: #0000c9;\n$primary7: #000093;\n$primary8: #00007a;\n$primary9: #000054;\n$primary10: #00003a;\n$primary11: #000078;\n$blueLogo: #000093;\n\n$neutral1: #fcfcfd;\n$neutral2: #f9f9fa;\n$neutral4: #e0e0e3;\n$neutral8: #838390;\n\n$success1: #f4fced;\n$success5: #58b441;\n$success6: #126f0e;\n\n$attention1: #fef9f0;\n$attention3: #fbd298;\n$attention5: #e78d3d;\n$attention7: #b94402;\n\n$danger1: #fdf1ed;\n$danger2: #f9d9cf;\n$danger3: #f4ada1;\n$danger5: #bd454a;\n$danger6: #911727;\n$danger7: #7c1028;\n\n\n$colabelNeutralLight: #F9F9FA;\n$colabelNeutralMid: #C3C3C9;\n$colabelNeutralDark: #121217;\n\n:export {\n    colabelNeutralLight: $colabelNeutralLight;\n    colabelNeutralMid: $colabelNeutralMid;\n    colabelNeutralDark: $colabelNeutralDark;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"colabelNeutralLight": `#F9F9FA`,
	"colabelNeutralMid": `#C3C3C9`,
	"colabelNeutralDark": `#121217`,
	"domains": `Activity_domains__zgIfo`
};
export default ___CSS_LOADER_EXPORT___;
